import Constants from '../utils/consts';
import SqlString from 'sqlstring';
var http = require('follow-redirects').http;
var qs = require('querystring');

export default async function sendMail(username, token, from, fromName, password, to, more, cc, bcc, toName, attachmentPath, subject, body) {
    return new Promise(function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/sendMail.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
           // const resp = JSON.parse(body.toString());
            resolve('OK');
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'uname': username,
            'token': token,
            'from': from,
            'fromName': fromName,
            'password': password,
            'to': to,
            'more_to': more,
            'cc': cc,
            'bcc': bcc,
            'toName': toName,
            'attachmentPath': attachmentPath,
            'subject': subject,
            'body': body
        });

        console.log(postData);
        req.write(postData);

        req.end();

        
    });
}
